var _ = require('underscore');
var module = angular.module('octopusApp.library');

module.controller('MergeConflictResolutionController', function ($scope, $uibModalInstance, $route, octopusRepository, usages, mergeResults, actionTemplate, busy) {

    var isSaving = $scope.isSaving = busy.create();

    $scope.showAutoDetails = false;
    $scope.showDefaultsDetails = false;
    $scope.showManualDetails = false;

    var mergeResultsByActionId = _.indexBy(mergeResults, 'Id');

    $scope.auto = usages.filter(function (usage) {
        return mergeResultsByActionId[usage.ActionId].Outcome === 'Success';
    });

    $scope.defaults = usages.filter(function (usage) {
        usage.NamesOfNewParametersMissingDefaultValue = mergeResultsByActionId[usage.ActionId].NamesOfNewParametersMissingDefaultValue;
        return mergeResultsByActionId[usage.ActionId].Outcome === 'DefaultParamterValueMissing';
    });
    var namesOfNewParameterMissingDefaultValue = _.uniq([].concat.apply([], $scope.defaults.map(function(d) { return d.NamesOfNewParametersMissingDefaultValue;})));
    $scope.newParametersMissingDefaultValue = actionTemplate.Parameters.filter(function(p) {
        return namesOfNewParameterMissingDefaultValue.indexOf(p.Name) !== -1;
    });
    $scope.defaultPropertyValues = {};
    namesOfNewParameterMissingDefaultValue.forEach(function(name){
       $scope.defaultPropertyValues[name] = null;
    });

    $scope.manual = usages.filter(function (usage) {
                                return mergeResultsByActionId[usage.ActionId].Outcome === 'ManualMergeRequired';
                            })
                            .map(function (usage) {
                                usage.ManualMergeRequiredReasonsByPropertyName = mergeResultsByActionId[usage.ActionId].ManualMergeRequiredReasonsByPropertyName;
                                return usage;
                            });

    $scope.appliesToSingleStep = $scope.auto.length + $scope.manual.length + $scope.defaults.length === 1;

    $scope.actionTemplate = actionTemplate;
    refreshUI();

    function refreshUI() {
        $scope.tab = $scope.auto.length ? 'auto' : ($scope.defaults.length ? 'defaults' : 'manual');
        if (!anythingToUpdate()) {
            $scope.cancel();
        }
    };

    function anythingToUpdate() {
        return $scope.auto.length !== 0 || $scope.defaults.length !== 0 || $scope.manual.length !== 0;
    };

    function updateActions(actionTemplate, usages, defaults) {

        var actionIdsByProcessId = _.groupBy(usages, 'DeploymentProcessId');
        for(var propertyName in actionIdsByProcessId) {
            actionIdsByProcessId[propertyName] = actionIdsByProcessId[propertyName].map(function(usage){return usage.ActionId;});
        }

        var work = octopusRepository.ActionTemplates
                                    .updateActions(actionTemplate, actionIdsByProcessId, defaults);

        return isSaving.promise(work);
    }

    $scope.update = function () {
        switch($scope.tab)
        {
            case "auto": return updateActions($scope.actionTemplate, $scope.auto).then(function(){
                $scope.auto = [];
                refreshUI();
            });
            case "defaults": return updateActions($scope.actionTemplate, $scope.defaults, $scope.defaultPropertyValues).then(function(){
                $scope.defaults = [];
                refreshUI();
            });;
        }
    };

    $scope.have = function(number){
        return number === 1 ? "has" : "have";
    };

    $scope.need = function(number){
        return number === 1 ? "needs" : "need";
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss();
    };

    $scope.changeTab = function (selectedTab) {
        $scope.tab = selectedTab;
    };

    $scope.toggleAutoDetails = function (){
        $scope.showAutoDetails = !$scope.showAutoDetails;
    };

    $scope.toggleDefaultsDetails = function (){
        $scope.showDefaultsDetails = !$scope.showDefaultsDetails;
    };

    $scope.toggleManualDetails = function (){
        $scope.showManualDetails = !$scope.showManualDetails;
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/merge_conflict_resolution_controller.js
// module id = 6303282790704623
// module chunks = 1